import { getSiteUrl } from './siteConfig';
import { normalizeIntakeHostname } from './intakePublicUrl';

/** DNS TXT record host prefix (record is `_nexus-booking.{yourBookingHostname}`). */
export const BOOKING_CUSTOM_HOST_TXT_PREFIX = '_nexus-booking';

export type OnlineBookingPortalUrlFields = {
  is_default: boolean;
  public_slug: string | null;
  custom_hostname?: string | null;
  custom_host_verified_at?: string | null;
};

export const normalizeOnlineBookingPortalHostname = normalizeIntakeHostname;

/** Public https origin for this portal when custom host is verified; otherwise main app URL. */
export function getOnlineBookingPublicOriginFromPortalRow(
  portal: OnlineBookingPortalUrlFields | null | undefined,
): string {
  const host = normalizeIntakeHostname(String(portal?.custom_hostname ?? ''));
  const verified = Boolean(portal?.custom_host_verified_at);
  if (host && verified) {
    return `https://${host}`;
  }
  return getSiteUrl();
}

/**
 * @param siteUrlOrOrigin — Pass `getSiteUrl()` or a verified custom origin from `getOnlineBookingPublicOriginFromPortalRow`.
 */
export function buildPublicOnlineBookingUrl(
  siteUrlOrOrigin: string,
  businessSlug: string,
  portal: OnlineBookingPortalUrlFields | null,
): string {
  const origin = siteUrlOrOrigin.replace(/\/$/, '');
  const base = `${origin}/${businessSlug}/book`;
  if (!portal?.public_slug || portal.is_default) {
    return base;
  }
  return `${base}/${portal.public_slug}`;
}
